import { ChatMessage } from './chat-message';
import { DateTimeHelper } from "src/app/core/helper/datetime.helper";

export class ChatThread {
    threadId: number;
    auctionId: number;
    productId: number;
    targetUserId: number;
    createdByUserId: number;
    author: number;
    hasUnread: boolean;
    targetUser: number;
    lastMessage: string;
    title: string;
    lastUser: string;
    lastModified: string;
    messages: ChatMessage[] = [];

    public constructor(thread?: Partial<ChatThread>) {
        Object.assign(this, thread);
        this.messages = this.messages.map(m => new ChatMessage(m));
        this.lastModified = DateTimeHelper.formatDate(this.lastModified);
    }
}
